import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {ListComponent} from'./list/list.component';
import { WizardComponent } from '@src/app/wizard/wizard.component';
import { ThankYouComponent } from './wizard/thank-you.component';
import { CardAddComponent } from './card-add/card-add.component';


const routes: Routes = [
  { path: '', component: WizardComponent },
  { path: 'wizard', component: WizardComponent },
  { path: 'thankyou', component: ThankYouComponent },
  { path: 'cardadd', component: CardAddComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
